import { useState } from 'react';
import { Search, MapPin, Briefcase, Mail, ChevronDown, ChevronUp, X, Send, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Candidate data organized by category
const candidatesByCategory = {
  'Finance & Accounting': [
    { id: 1, title: 'Real Estate CFO', location: 'Northern NJ' },
    { id: 2, title: 'CPA / Controller', location: 'Monsey / Rockland' },
    { id: 3, title: 'CPA / Finance Leadership', location: 'NYC' },
    { id: 4, title: 'CPA / Nonprofit Finance', location: 'Five Towns / Far Rockaway' },
    { id: 5, title: 'Controller', location: 'Lakewood' },
    { id: 6, title: 'Controller', location: 'Five Towns / Far Rockaway' },
    { id: 7, title: 'Accountant', location: 'Rockland County' },
    { id: 8, title: 'Actuary', location: 'Five Towns' },
    { id: 9, title: 'CPA / Controller', location: 'Northern NJ' },
    { id: 10, title: 'CFO / FP&A / Financial Analysis', location: 'Northern NJ' },
  ],
  'Operations & Executive Leadership': [
    { id: 11, title: 'Senior Operations / P&L / Process & Performance Management', location: 'Five Towns' },
    { id: 12, title: 'Operations / Growth / Organizational Scaling', location: 'Rockland County' },
    { id: 13, title: 'Lending / Private Credit / Operations', location: 'Connecticut' },
    { id: 14, title: 'Nonprofit Operations / Finance / Facilities', location: 'Brooklyn' },
    { id: 15, title: 'COO / Operations / Scaling & Supply Chain', location: 'Five Towns' },
    { id: 16, title: 'Operations / Credit / Process Improvement', location: 'Five Towns' },
    { id: 17, title: 'Operations / Logistics / Business Growth', location: 'Brooklyn' },
    { id: 18, title: 'Construction Project Coordination', location: 'Brooklyn' },
    { id: 19, title: 'IT Project Management / Systems Integration / Digital Transformation', location: 'Brooklyn' },
    { id: 20, title: 'Senior Operations / Office Administration', location: 'Brooklyn' },
    { id: 21, title: 'Purchasing / Office Management / Property Operations', location: 'Five Towns / Far Rockaway' },
    { id: 22, title: 'Business Operations / Systems / Software Development', location: 'Five Towns' },
  ],
  'Technology, Cybersecurity & QA': [
    { id: 23, title: 'Enterprise Technology / Cloud / Platforms', location: 'Five Towns' },
    { id: 24, title: 'IT Infrastructure / Systems / Security', location: 'Lakewood' },
    { id: 25, title: 'Technology / BI / Client Success', location: 'Lakewood' },
    { id: 26, title: 'IT Audit / Technology Risk', location: 'Five Towns' },
    { id: 27, title: 'Cybersecurity', location: 'Staten Island' },
    { id: 28, title: 'IT / Cybersecurity', location: 'Northern NJ' },
    { id: 29, title: 'Quality Assurance / Test Management', location: 'Brooklyn' },
    { id: 30, title: 'Software Development', location: 'Brooklyn' },
  ],
  'Real Estate, Property & Lending': [
    { id: 31, title: 'Property Management', location: 'Five Towns' },
    { id: 32, title: 'Real Estate / Asset Management', location: 'Brooklyn' },
    { id: 33, title: 'Real Estate / Financing', location: 'Brooklyn' },
    { id: 34, title: 'Commercial Lending / Credit / Relationship Management', location: 'Five Towns / Far Rockaway' },
    { id: 35, title: 'Real Estate', location: 'Five Towns' },
  ],
  'Risk, Banking & Financial Services': [
    { id: 36, title: 'Risk Assessment / Controls', location: 'Five Towns' },
    { id: 37, title: 'Enterprise Risk / Banking', location: 'Northern NJ' },
    { id: 38, title: 'Financial Services', location: 'Northern NJ' },
    { id: 39, title: 'Banking / Financial Services', location: 'Brooklyn' },
  ],
  'Sales, Business Development & Client Relations': [
    { id: 40, title: 'Sales Planning', location: 'Westchester' },
    { id: 41, title: 'Sales / Legal', location: 'Brooklyn' },
    { id: 42, title: 'Collections / Customer Service', location: 'Brooklyn' },
    { id: 43, title: 'Retail / Apparel', location: 'Great Neck / North Shore' },
    { id: 44, title: 'Operations / Client Relations / Business Development', location: 'Queens' },
    { id: 45, title: 'Healthcare / Homecare Business Development & Sales', location: 'Five Towns' },
  ],
  'Nonprofit & Education': [
    { id: 46, title: 'Judaic Studies / School Administration', location: 'Five Towns / Far Rockaway' },
    { id: 47, title: 'Education / Title I / ABA', location: 'Brooklyn' },
    { id: 48, title: 'Nonprofit Leadership / Mental Health Expertise', location: 'Lakewood' },
    { id: 49, title: 'Development / Nonprofit Leadership', location: 'Rockland County' },
    { id: 50, title: 'School Administration', location: 'Five Towns / Far Rockaway' },
    { id: 51, title: 'Nonprofit Finance / CPA', location: 'Five Towns / Far Rockaway' },
    { id: 52, title: 'Teacher / Curriculum Development', location: 'Central NJ' },
  ],
  'Human Resources & Administration': [
    { id: 53, title: 'HR / Organizational Development', location: 'Five Towns' },
    { id: 54, title: 'Senior Administration / Technology', location: 'Brooklyn' },
    { id: 55, title: 'HR Operations / Credentialing / Administration', location: 'Brooklyn' },
    { id: 56, title: 'Administration / Client Services / Care Coordination', location: 'Monsey' },
  ],
  'Legal': [
    { id: 57, title: 'Attorney', location: 'Northern NJ' },
    { id: 58, title: 'Director of Legal', location: 'Five Towns' },
    { id: 59, title: 'Legal Administration', location: 'Brooklyn' },
  ],
  'Healthcare & Life Sciences': [
    { id: 60, title: 'Nursing Home Administration', location: 'Five Towns' },
    { id: 61, title: 'Biopharma / Regulatory Affairs / CMC', location: 'Central NJ' },
    { id: 62, title: 'Physician', location: 'Brooklyn' },
  ],
  'Creative, Content & Marketing': [
    { id: 63, title: 'Content Strategy', location: 'Monsey' },
    { id: 64, title: 'Creative Direction', location: 'Five Towns / Far Rockaway' },
    { id: 65, title: 'Writer / Content', location: 'Brooklyn' },
    { id: 66, title: 'Graphic Design / Creative Direction', location: 'Five Towns / Far Rockaway' },
    { id: 67, title: 'Marketing / Strategic Communications / Brand & Content', location: 'Riverdale / Bronx' },
    { id: 68, title: 'Digital Asset Management / Product Data / Fashion', location: 'Brooklyn' },
  ],
};

// Generate mailto link with subject
const generateMailtoLink = (jobTitle) => {
  const subject = encodeURIComponent(`${jobTitle} Inquiry`);
  return `mailto:info@aim-hire.org?subject=${subject}`;
};

// Inquiry Modal Component
const InquiryModal = ({ isOpen, onClose, jobTitle, location }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${API_URL}/api/talent-inquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          jobTitle,
          location,
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', company: '', message: '' });
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div 
        className="relative bg-white rounded-xl shadow-2xl w-full max-w-md p-6 animate-fade-in-up"
        data-testid="inquiry-modal"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors"
          aria-label="Close modal"
        >
          <X className="w-5 h-5" />
        </button>

        <h3 
          className="text-xl font-bold text-slate-900 mb-4"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Inquire About Candidate
        </h3>

        {submitStatus === 'success' ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Send className="w-8 h-8 text-green-600" />
            </div>
            <p className="text-lg font-medium text-slate-900">Inquiry Sent!</p>
            <p className="text-sm text-slate-600 mt-1">We'll be in touch shortly.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Auto-filled Position field */}
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-3">
              <label className="block text-xs font-medium text-purple-600 uppercase tracking-wide mb-1">
                Position
              </label>
              <p className="text-base font-semibold text-slate-900">{jobTitle}</p>
              <p className="text-sm text-slate-500">{location}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Your Name *
              </label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="John Smith"
                data-testid="inquiry-name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Your Email *
              </label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="john@company.com"
                data-testid="inquiry-email"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Company
              </label>
              <input
                type="text"
                value={formData.company}
                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="Your company name"
                data-testid="inquiry-company"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Message
              </label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                rows={3}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
                placeholder="I'm interested in learning more about this candidate..."
                data-testid="inquiry-message"
              />
            </div>

            {submitStatus === 'error' && (
              <p className="text-sm text-red-600">
                Something went wrong. Please try again or email us directly.
              </p>
            )}

            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-slate-900 hover:bg-purple-600 text-white rounded-full py-3 text-base font-medium transition-colors"
              data-testid="inquiry-submit"
            >
              {isSubmitting ? 'Sending...' : 'Send Inquiry'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

// Candidate Card Component
const CandidateCard = ({ candidate, onOpenModal }) => {
  return (
    <div
      className="bg-white rounded-lg border border-slate-200 p-4 hover:border-purple-300 hover:shadow-md transition-all duration-200 group"
      data-testid={`candidate-${candidate.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-base font-semibold text-slate-900 group-hover:text-purple-600 transition-colors">
            {candidate.title}
          </h4>
          <div className="flex items-center mt-1 text-sm text-slate-500">
            <MapPin className="w-3.5 h-3.5 mr-1 flex-shrink-0" />
            <span>{candidate.location}</span>
          </div>
          
          {/* Action buttons */}
          <div className="flex items-center gap-3 mt-3">
            <a
              href={generateMailtoLink(candidate.title)}
              className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-purple-600 transition-colors"
              data-testid={`mailto-${candidate.id}`}
            >
              <Mail className="w-4 h-4" />
              <span>Email</span>
            </a>
            <span className="text-slate-300">|</span>
            <button
              onClick={() => onOpenModal(candidate)}
              className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-purple-600 transition-colors"
              data-testid={`form-${candidate.id}`}
            >
              <FileText className="w-4 h-4" />
              <span>Quick Form</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Category Section Component
const CategorySection = ({ category, candidates, isExpanded, onToggle, onOpenModal }) => {
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden bg-white" data-testid={`category-${category}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 md:p-5 bg-slate-50 hover:bg-slate-100 transition-colors text-left"
      >
        <div className="flex items-center gap-3">
          <Briefcase className="w-5 h-5 text-slate-600" />
          <h3 
            className="text-lg font-semibold text-slate-900"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {category}
          </h3>
          <span className="bg-slate-200 text-slate-600 text-sm px-2 py-0.5 rounded-full">
            {candidates.length}
          </span>
        </div>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-slate-500" />
        ) : (
          <ChevronDown className="w-5 h-5 text-slate-500" />
        )}
      </button>
      
      {isExpanded && (
        <div className="p-4 md:p-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {candidates.map((candidate) => (
            <CandidateCard 
              key={candidate.id} 
              candidate={candidate} 
              onOpenModal={onOpenModal}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default function Talent() {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedCategories, setExpandedCategories] = useState(
    Object.keys(candidatesByCategory).reduce((acc, cat) => ({ ...acc, [cat]: true }), {})
  );
  const [modalCandidate, setModalCandidate] = useState(null);

  // Filter candidates based on search
  const filteredCategories = Object.entries(candidatesByCategory).reduce((acc, [category, candidates]) => {
    const filtered = candidates.filter(
      (c) =>
        c.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.location.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (filtered.length > 0) {
      acc[category] = filtered;
    }
    return acc;
  }, {});

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const expandAll = () => {
    setExpandedCategories(
      Object.keys(candidatesByCategory).reduce((acc, cat) => ({ ...acc, [cat]: true }), {})
    );
  };

  const collapseAll = () => {
    setExpandedCategories(
      Object.keys(candidatesByCategory).reduce((acc, cat) => ({ ...acc, [cat]: false }), {})
    );
  };

  const openModal = (candidate) => {
    setModalCandidate(candidate);
  };

  const closeModal = () => {
    setModalCandidate(null);
  };

  const totalCandidates = Object.values(candidatesByCategory).flat().length;
  const filteredTotal = Object.values(filteredCategories).flat().length;

  return (
    <div data-testid="talent-page">
      {/* Inquiry Modal */}
      <InquiryModal
        isOpen={!!modalCandidate}
        onClose={closeModal}
        jobTitle={modalCandidate?.title || ''}
        location={modalCandidate?.location || ''}
      />

      {/* Hero Section */}
      <section className="relative bg-slate-800 overflow-hidden pt-40 md:pt-[calc(12rem+10vh)] pb-12 md:pb-16" data-testid="talent-hero">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700" />
        
        <div className="relative container mx-auto px-4 md:px-8 lg:px-12 max-w-6xl">
          <div className="max-w-3xl">
            <h1 
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 animate-fade-in-up"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              <span className="text-purple-200 italic">Available Talent</span>
            </h1>
            <p className="text-base md:text-lg text-slate-300 mb-8 leading-relaxed animate-fade-in-up animation-delay-100">
              Browse our current roster of experienced professionals ready for their next opportunity. Click any position to inquire directly.
            </p>
          </div>
        </div>
      </section>

      {/* Search & Filter Section */}
      <section className="py-8 bg-white border-b border-slate-200 sticky top-0 z-40" data-testid="talent-search">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 max-w-6xl">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            {/* Search Bar */}
            <div className="relative w-full md:w-96">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
              <input
                type="text"
                placeholder="Search by title or location..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                data-testid="talent-search-input"
              />
            </div>

            {/* Stats & Controls */}
            <div className="flex items-center gap-4">
              <span className="text-sm text-slate-600">
                {searchTerm ? `${filteredTotal} of ${totalCandidates}` : `${totalCandidates}`} professionals
              </span>
              <div className="flex gap-2">
                <button
                  onClick={expandAll}
                  className="text-sm text-slate-600 hover:text-purple-600 transition-colors"
                >
                  Expand All
                </button>
                <span className="text-slate-300">|</span>
                <button
                  onClick={collapseAll}
                  className="text-sm text-slate-600 hover:text-purple-600 transition-colors"
                >
                  Collapse All
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Candidates Grid */}
      <section className="py-12 md:py-16 bg-slate-50" data-testid="talent-grid">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 max-w-6xl">
          <div className="space-y-4">
            {Object.entries(filteredCategories).map(([category, candidates]) => (
              <CategorySection
                key={category}
                category={category}
                candidates={candidates}
                isExpanded={expandedCategories[category]}
                onToggle={() => toggleCategory(category)}
                onOpenModal={openModal}
              />
            ))}
          </div>

          {Object.keys(filteredCategories).length === 0 && (
            <div className="text-center py-12 bg-white rounded-xl border border-slate-100">
              <p className="text-slate-600">No candidates found matching "{searchTerm}"</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-white" data-testid="talent-cta">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 max-w-6xl">
          <div className="bg-slate-900 rounded-xl p-8 md:p-12 text-center">
            <h2 
              className="text-2xl md:text-3xl font-bold text-white mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Looking for a Specific Skill Set?
            </h2>
            <p className="text-base text-slate-300 mb-6 max-w-2xl mx-auto">
              Don't see exactly what you need? Contact us and we'll help you find the right candidate from our network.
            </p>
            <a href="/contact" data-testid="talent-contact-btn">
              <Button className="bg-white hover:bg-slate-100 text-slate-900 rounded-full px-10 py-6 text-lg font-medium">
                Contact Us
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
